var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30.5C23.7843 30.5 30.5 23.7843 30.5 15.5C30.5 7.21573 23.7843 0.5 15.5 0.5C7.21573 0.5 0.5 7.21573 0.5 15.5C0.5 23.7843 7.21573 30.5 15.5 30.5Z",
    stroke: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3941 18.2152C10.9281 18.2152 11.4501 18.0568 11.8941 17.7602C12.3381 17.4635 12.6842 17.0418 12.8886 16.5484C13.0929 16.0551 13.1464 15.5122 13.0422 14.9884C12.938 14.4647 12.6809 13.9836 12.3033 13.606C11.9257 13.2284 11.4446 12.9712 10.9208 12.8671C10.3971 12.7629 9.85421 12.8164 9.36085 13.0207C8.86749 13.2251 8.4458 13.5711 8.14912 14.0151C7.85244 14.4592 7.69409 14.9812 7.69409 15.5152C7.69409 15.8698 7.76393 16.2209 7.89962 16.5484C8.0353 16.876 8.23419 17.1737 8.4849 17.4244C8.99125 17.9307 9.67801 18.2152 10.3941 18.2152V18.2152Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8372 24.2862C20.3712 24.2862 20.8932 24.1279 21.3372 23.8312C21.7813 23.5345 22.1273 23.1128 22.3317 22.6195C22.536 22.1261 22.5895 21.5832 22.4853 21.0595C22.3811 20.5357 22.124 20.0546 21.7464 19.677C21.3688 19.2994 20.8877 19.0423 20.364 18.9381C19.8402 18.8339 19.2973 18.8874 18.804 19.0918C18.3106 19.2961 17.8889 19.6422 17.5922 20.0862C17.2956 20.5302 17.1372 21.0522 17.1372 21.5862C17.1372 22.3023 17.4217 22.9891 17.928 23.4954C18.4344 24.0018 19.1211 24.2862 19.8372 24.2862V24.2862Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8372 12.1451C20.3712 12.1451 20.8932 11.9868 21.3372 11.6901C21.7813 11.3934 22.1273 10.9717 22.3317 10.4784C22.536 9.985 22.5895 9.44212 22.4853 8.91837C22.3811 8.39463 22.124 7.91353 21.7464 7.53593C21.3688 7.15833 20.8877 6.90118 20.364 6.797C19.8402 6.69282 19.2973 6.74629 18.804 6.95064C18.3106 7.155 17.8889 7.50107 17.5922 7.94508C17.2956 8.38909 17.1372 8.91111 17.1372 9.44512C17.1372 10.1612 17.4217 10.848 17.928 11.3543C18.4344 11.8607 19.1211 12.1451 19.8372 12.1451Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.566 10.9011L12.666 14.0541",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6611 16.9722L17.5611 20.1252",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.82f88eaceaa49646d1f9074dd3356af9.svg";
export { ForwardRef as ReactComponent };